'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentRest = function () {
  function ComponentRest($http) {
    (0, _classCallCheck3.default)(this, ComponentRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      COMPONENTS_LIST: 'dashboards/%1$s/components/',
      COMPONENTS_DETAIL: 'dashboards/%1$s/components/%2$s/',
      COMPONENTS_RENDER: 'dashboards/%1$s/components/%2$s/render/',
      COMPONENTS_VIZ_CHOICES: 'dashboards/available-visualizations/'
    };
  }

  (0, _createClass3.default)(ComponentRest, [{
    key: 'getChartChoices',
    value: function getChartChoices(dashboardId) {
      var choices = [{ "value": "LN", "label": "Line chart" }, { "value": "LD", "label": "Line+markers chart" }, { "value": "SC", "label": "Scatter plot" }, { "value": "BR", "label": "Bar chart" }, { "value": "PI", "label": "Pie chart" }, { "value": "CO", "label": "Choropleth" }, { "value": "MP", "label": "Model Performance" }, { "value": "MB", "label": "Metric Banner" }, { "value": "TB", "label": "Table" }, { "value": "GP", "label": "Grades Performance" }];
      return choices;
    }
  }, {
    key: 'create',
    value: function create(dashboardId, postData) {
      return this.$http.post(this.sprintf(this.PATH.COMPONENTS_LIST, dashboardId), postData);
    }
  }, {
    key: 'update',
    value: function update(dashboardId, id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.COMPONENTS_DETAIL, dashboardId, id), postData);
    }
  }, {
    key: 'save',
    value: function save(dashboardId, postData) {
      return postData.id ? this.update(dashboardId, postData.id, postData) : this.create(dashboardId, postData);
    }
  }, {
    key: 'getList',
    value: function getList(dashboardId, params) {
      return this.$http.get(this.sprintf(this.PATH.COMPONENTS_LIST, dashboardId), { params: params });
    }
  }, {
    key: 'read',
    value: function read(dashboardId, id) {
      return this.$http.get(this.sprintf(this.PATH.COMPONENTS_DETAIL, dashboardId, id));
    }
  }, {
    key: 'delete',
    value: function _delete(dashboardId, id) {
      return this.$http.delete(this.sprintf(this.PATH.COMPONENTS_DETAIL, dashboardId, id));
    }
  }, {
    key: 'render',
    value: function render(dashboardId, id, datesRange) {
      var data = {};

      for (var k in datesRange) {
        if (datesRange[k]) {
          data[k] = datesRange[k];
        }
      }

      return this.$http.get(this.sprintf(this.PATH.COMPONENTS_RENDER, dashboardId, id), { "params": data });
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview(dashboardId, postData, datesRange) {
      var query_params = {};

      for (var k in datesRange) {
        if (datesRange[k]) {
          query_params[k] = datesRange[k];
        }
      }

      return this.$http.post(this.sprintf(this.PATH.COMPONENTS_LIST + 'render-preview/', dashboardId), postData, { "params": query_params });
    }
  }]);
  return ComponentRest;
}();

exports.default = ComponentRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/ComponentResource.js
// module id = 307
// module chunks = 0